import React , { useEffect }from "react";
export default ({
    mode = "reload"
}) => {

    useEffect(() => {
        const fn = () => {
            
        }
        const unlisten = window.addEventListener("resize", fn)
        return () => {
            unlisten();
        }
    }, [])
}